import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts";
import { Payment } from "@/components/settings/admin/stats/payments/types";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useTheme } from "next-themes";
import { getPaymentDate } from "@/lib/paymentDate";

interface PaymentsChartProps {
  payments: Payment[];
}

export const PaymentsChart = ({ payments }: PaymentsChartProps) => {
  const { theme } = useTheme();
  
  const monthlyData = payments.reduce((acc: any[], payment) => {
    const date = getPaymentDate(payment as any);
    const monthYear = format(date, "MMMM yyyy", { locale: es });
    
    const existingMonth = acc.find(item => item.month === monthYear);
    if (existingMonth) {
      existingMonth.total += Number(payment.amount);
      existingMonth.count += 1;
    } else {
      acc.push({
        month: monthYear,
        total: Number(payment.amount),
        count: 1
      });
    }
    return acc;
  }, []);

  // Color que responde al tema
  const barColor = theme === "dark" ? "hsl(187, 100%, 42%)" : "hsl(187, 100%, 35%)";
  const axisColor = theme === "dark" ? "hsl(0, 0%, 70%)" : "hsl(0, 0%, 45%)";

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={monthlyData}>
        <XAxis 
          dataKey="month" 
          stroke={axisColor}
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke={axisColor}
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={(value) => `$${value}`}
        />
        <Tooltip 
          formatter={(value: number) => [`$${value}`, "Total"]}
          cursor={{ fill: "transparent" }}
        />
        <Bar 
          dataKey="total" 
          fill={barColor}
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};